import { graphql } from "@/gql";

export const organisationVerificationCountsQuery = graphql(`
  query OrganisationVerificationCounts {
    unverified: organisations(first: 1, is_verified: false) {
      paginatorInfo {
        total
      }
    }
    verified: organisations(first: 1, is_verified: true) {
      paginatorInfo {
        total
      }
    }
  }
`);
